module.exports = __webpack_public_path__ + "img/sld_scb_8_t1_b1_dark.9e4bb51d.svg";